import axios from './auth'

const MENU_BASE_URL = `${process.env.VUE_APP_API_OPS_BASE_URL}/menus`;

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getMenus({ commit }, params = {}) {
    const url = MENU_BASE_URL;

    const method = "get";
    const headers = {};
    const config = {
      url,
      method,
      headers,
      params
    };

    try {
      const response = await axios(config);
      let data = response.data.data;
      return {
        status: 'success',
        data,
      };
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data
      };
    }
  },
  async getMenusByRole({ commit }, payload) {
    const url = `${MENU_BASE_URL}/role/${payload}`;

    const method = "get";
    const headers = {};
    const config = {
      url,
      method,
      headers
    };

    try {
      const response = await axios(config);
      let data = response.data.data;
      return {
        status: 'success',
        data,
      };
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data
      };
    }
  },
  async saveRolePrivilege({ commit }, payload) {
    const url = `${MENU_BASE_URL}/role/${payload.roleId}`;

    const method = "post";
    const headers = {
      "Accept": "application/json",
      "Content-Type": "application/json"
    };
    const config = {
      url,
      method,
      data: payload.data,
      headers
    };

    try {
      const response = await axios(config);
      let data = response.data.data;
      return {
        status: 'success',
        data,
      };
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data
      };
    }
  },
}
